import styled from "styled-components";

export const ModalHealthDetailContent = styled.div`
  width: 100%;
  display: flex;
  padding-top: 20px;
  flex-direction: column;
`;

export const SrcText = styled.div`
  gap: 4px;
  color: ${(props) => props.theme.colors.black60};
  display: flex;
  padding: 10px 20px;
  font-size: 1.2rem;
  align-items: center;
  justify-content: flex-end;

  a {
    color: ${(props) => props.theme.colors.primary100};
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;
